module.exports = __webpack_public_path__ + "static/media/178602B.a08d353b.jpg";